// import React from "react"; tidak perlu import react
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
// import "swiper/css";

ReactDOM.render(<App />, document.getElementById("root"));
